var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#9664F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14526 8.24902V4.02148H5.86206C7.13647 4.02148 7.8894 4.75977 7.8894 6.10449V6.11035C7.8894 7.46094 7.13647 8.24902 5.86206 8.24902H4.14526ZM5.22046 7.38184H5.72144C6.42163 7.38184 6.79663 6.95703 6.79663 6.11328V6.10742C6.79663 5.31641 6.39819 4.88867 5.72144 4.88867H5.22046V7.38184Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/D.09a7a7ec71c644c3be050da0c7cd2ae8.svg";
export { ForwardRef as ReactComponent };